import React, { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import "../BitacoraProduccion.css";
import "../BitacoraEnvasado.css";
import { obtenerCatalogoMaguey } from "../../../../redux/DucksBeneficiario/BitacoraProduccionDucks";

// Material UI Icons
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import UndoIcon from '@mui/icons-material/Undo';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import OpacityIcon from '@mui/icons-material/Opacity';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import BiotechIcon from '@mui/icons-material/Biotech';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HistoryIcon from '@mui/icons-material/History';
import SendIcon from '@mui/icons-material/Send';
import RefreshIcon from '@mui/icons-material/Refresh';
import DescriptionIcon from '@mui/icons-material/Description';
import { obtenerGranelesAlmacenPorLogin } from "../../../../redux/DucksBeneficiario/BitacoraAlmacenDucks";

// Sub-componentes Modales por Apartado (Modularizados)
import ModalFormGranel from "./modales/ModalFormGranel";
import ModalDetalleGranel from "./modales/ModalDetalleGranel";
import ModalFusionGranel from "./modales/ModalFusionGranel";
import ModalTrasladoGranel from "./modales/ModalTrasladoGranel";
import ModalDilucionGranel from "./modales/ModalDilucionGranel";
import ModalBajaGranel from "./modales/ModalBajaGranel";
import ModalMuestreoGranel from "./modales/ModalMuestreoGranel";
import ModalMovimientosGranel from "./modales/ModalMovimientosGranel";
import ModalDocumentosGranelAlmacen from "./ModalDocumentosGranelAlmacen";

const InventarioGranelSection = ({
  granelRecords = [],
  allGranelRecords = [],
  produccionLots = [],
  destilacionRecords = [],
  catalogoMaguey = [],
  availableInstalaciones = [],
  isFormOpen,
  setIsFormOpen,
  formData = {},
  setFormData,
  handleSaveGranel,
  handleCancelGranel,
  handleSaveFusion,
  handleUndoGranel,
  handleSaveTraslado,
  handleSaveDilucion,
  handleSaveBaja,
  handleSaveMuestreo,
  onRegistrarEnvasado,
  handleRefreshGranel,
  isRefreshingGranel = false,
  pagination = { total: 0, page: 1, limit: 10, totalPages: 1 },
  currentPage = 1,
  setCurrentPage,
  limit = 10,
  setLimit,
  onPageChange,
  onLimitChange
}) => {
  const dispatch = useDispatch();
  const [localRefreshing, setLocalRefreshing] = useState(false);
  const isRefreshing = isRefreshingGranel || localRefreshing;
  const reduxUser = useSelector(state => state.Usuario?.data?.user?.[0] || state.Usuario?.user?.[0] || state.Usuario || null);

  const handleRefresh = async () => {
    if (handleRefreshGranel) {
      await handleRefreshGranel();
    } else if (dispatch) {
      setLocalRefreshing(true);
      try {
        const idLogin = reduxUser?.id || reduxUser?.idlogin;
        if (idLogin) {
          await dispatch(obtenerGranelesAlmacenPorLogin(idLogin));
        }
      } catch (err) {
        console.error("Error refreshing granel:", err);
      } finally {
        setTimeout(() => setLocalRefreshing(false), 500);
      }
    }
  };

  useEffect(() => {
    if (dispatch) {
      dispatch(obtenerCatalogoMaguey());
    }
  }, [dispatch]);

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [documentosModalRecord, setDocumentosModalRecord] = useState(null);
  const [isDocumentosModalOpen, setIsDocumentosModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("todos");
  const [claseFilter, setClaseFilter] = useState("todos");
  const [tipoGranelFilter, setTipoGranelFilter] = useState("todos"); // 'todos' | 'granel' | 'maduracion' | 'producto_terminado'

  const esProductoTerminado = (rec) => {
    if (!rec) return false;
    const tipo = String(rec.tipo_granel || rec.tipoGranel || '').toLowerCase();
    const origen = String(rec.origen_registro || rec.origenRegistro || '').toLowerCase();
    const obs = String(rec.observaciones || '').toLowerCase();
    return tipo === 'producto_terminado' || origen === 'producto_terminado' || Number(rec.botellas) > 0 || obs.includes('envasado terminado') || obs.includes('producto terminado');
  };

  const esGranelMaduracion = (rec) => {
    if (!rec || esProductoTerminado(rec)) return false;
    const tipo = String(rec.tipo_granel || rec.tipoGranel || '').toLowerCase();
    const origen = String(rec.origen_registro || rec.origenRegistro || '').toLowerCase();
    const obs = String(rec.observaciones || '').toLowerCase();
    const clase = String(rec.clase || '').toLowerCase();
    return tipo === 'maduracion' || tipo === 'granel_maduracion' || origen === 'maduracion' || obs.includes('madurac') || obs.includes('barrica') || Boolean(rec.no_barricas || rec.noBarricas) || clase.includes('madurado en vidrio');
  };

  const esGranelRegular = (rec) => {
    return !esProductoTerminado(rec) && !esGranelMaduracion(rec);
  };

  const countsByTipo = useMemo(() => {
    const validRecs = (granelRecords || []).filter(rec => {
      const saldoFinalNum = parseFloat(String(rec.invFinalVol ?? rec.volFinal ?? rec.saldoFinal ?? rec.litros ?? rec.litrosTotal ?? 0).replace(/[^\d.]/g, '')) || 0;
      return saldoFinalNum > 0;
    });

    let granel = 0;
    let maduracion = 0;
    let terminado = 0;

    validRecs.forEach(rec => {
      if (esProductoTerminado(rec)) terminado++;
      else if (esGranelMaduracion(rec)) maduracion++;
      else granel++;
    });

    return {
      todos: validRecs.length,
      granel,
      maduracion,
      terminado
    };
  }, [granelRecords]);

  // Filtrar exclusivamente instalaciones de Almacén del asociado
  const almacenInstalaciones = useMemo(() => {
    const list = (availableInstalaciones || []).filter(inst => {
      const idTipo = Number(inst.idtipoanexo);
      const tipo = String(inst.tipo || inst.informaciongeneralinstalacioncliente?.tipo || '').toLowerCase();
      const alias = String(inst.alias || inst.informaciongeneralinstalacioncliente?.alias || '').toLowerCase();
      return idTipo === 3 || tipo.includes('almac') || alias.includes('almac') || tipo.includes('bodega') || alias.includes('bodega');
    });
    return list.length > 0 ? list : (availableInstalaciones || []);
  }, [availableInstalaciones]);
  const envasadoInstalaciones = almacenInstalaciones;

  // Función para obtener el alias real de la instalación del granel
  const getInstalacionAlias = (rec) => {
    if (!rec) return "Instalación Principal";

    const targetId = rec.id_unidad_produccion || rec.id_anexo_cliente;
    if (targetId) {
      const allInst = [...(envasadoInstalaciones || []), ...(availableInstalaciones || [])];
      const found = allInst.find(i => String(i.idanexocliente || i.id || i.id_instalacion) === String(targetId));
      const alias = found?.informaciongeneralinstalacioncliente?.alias || found?.alias;
      if (alias && alias !== "Instalación Principal") return alias;
    }

    if (rec.instalacion && rec.instalacion !== "Instalación Principal") {
      return rec.instalacion;
    }

    if (rec.instalacionOrigen && rec.instalacionOrigen !== "Instalación Principal") {
      return rec.instalacionOrigen;
    }

    const nestedAlias = rec.anexo_cliente?.informaciongeneralinstalacioncliente?.alias || rec.informaciongeneralinstalacioncliente?.alias;
    if (nestedAlias) return nestedAlias;

    const firstInst = (envasadoInstalaciones && envasadoInstalaciones.length > 0) ? envasadoInstalaciones[0] : (availableInstalaciones && availableInstalaciones.length > 0 ? availableInstalaciones[0] : null);
    const fallbackAlias = firstInst?.informaciongeneralinstalacioncliente?.alias || firstInst?.alias;
    if (fallbackAlias && fallbackAlias !== "Instalación Principal") {
      return fallbackAlias;
    }

    return rec.instalacion || rec.instalacionOrigen || "Instalación Principal";
  };

  const reduxCatalogo = useSelector(state => state.bitacoraProduccion?.catalogoMaguey || []);
  const activeCatalog = useMemo(() => {
    let list = [];
    if (Array.isArray(catalogoMaguey) && catalogoMaguey.length > 0) list = catalogoMaguey;
    else if (Array.isArray(reduxCatalogo) && reduxCatalogo.length > 0) list = reduxCatalogo;

    if (list.length > 0) {
      return [...list].sort((a, b) => {
        const nameA = (a.nombre_comun || a.nombreComun || '').toLowerCase();
        const nameB = (b.nombre_comun || b.nombreComun || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }

    return [
      { nc: 1, nombre_comun: "Espadín", nombre_cientifico: "Agave angustifolia Haw" },
      { nc: 2, nombre_comun: "Tobalá", nombre_cientifico: "Agave potatorum Zucc" },
      { nc: 3, nombre_comun: "Arroqueño", nombre_cientifico: "Agave americana L." },
      { nc: 4, nombre_comun: "Tepeztate", nombre_cientifico: "Agave marmorata" },
      { nc: 5, nombre_comun: "Mexicano", nombre_cientifico: "Agave rhodacantha" },
      { nc: 6, nombre_comun: "Madrecuixe / Cuishe", nombre_cientifico: "Agave karwinskii" },
      { nc: 7, nombre_comun: "Jabalí", nombre_cientifico: "Agave convallis" },
      { nc: 8, nombre_comun: "Chiquilao", nombre_cientifico: "Agave seemanniana" }
    ];
  }, [catalogoMaguey, reduxCatalogo]);

  // Catálogo completo de lotes de granel disponibles (usando allGranelRecords sin paginar si existe, o granelRecords)
  const allAvailableGraneles = useMemo(() => {
    const list = (Array.isArray(allGranelRecords) && allGranelRecords.length > 0)
      ? allGranelRecords
      : (Array.isArray(granelRecords) ? granelRecords : []);

    const seen = new Set();
    const result = [];

    list.forEach((g, gIdx) => {
      const gId = g.id_bitacora_granel || g.id || g.dbId;
      const gKey = gId ? String(gId) : `idx-${gIdx}-${g.no_lote || g.noLote || ''}`;
      if (seen.has(gKey)) return;
      seen.add(gKey);

      const vDisp = parseFloat(String(g.invFinalVol ?? g.saldoFinal ?? g.volFinal ?? g.volumen ?? g.litros ?? g.litrosTotal ?? g.entradaVolumen ?? 0).replace(/[^\d.]/g, '')) || 0;
      const aDisp = parseFloat(String(g.porcentaje_alc_vol ?? g.invFinalAlc ?? g.alcFinal ?? g.entradaAlc ?? 0).replace(/[^\d.]/g, '')) || 0;
      const optVal = String(g.id_bitacora_granel || g.id || g.dbId || g.noLote || g.no_lote || gIdx);
      const loteName = g.noLote || g.no_lote || 'Sin Lote';
      const tanqueName = g.idContenedor || g.no_tanque || 'S/N';
      const catName = g.categoria || 'Mezcal';
      const claseName = g.clase || 'Sin Clase';

      result.push({
        ...g,
        _vDisp: vDisp,
        _aDisp: aDisp,
        _optVal: optVal,
        _label: `${loteName} (Tanque: ${tanqueName}) - ${catName} | ${claseName} (Disp: ${vDisp.toLocaleString()} L @ ${aDisp}%)`
      });
    });

    return result;
  }, [allGranelRecords, granelRecords]);

  // Estado para Modal de Fusión / Mezcla / Extracción Parcial de Graneles
  const [isFusionModalOpen, setIsFusionModalOpen] = useState(false);
  const [isSubmittingFusion, setIsSubmittingFusion] = useState(false);
  const [fusionSources, setFusionSources] = useState([
    { granelId: "", volExtraer: "" },
    { granelId: "", volExtraer: "" }
  ]);
  const [fusionForm, setFusionForm] = useState({
    fechaMovimiento: new Date().toISOString().split('T')[0],
    noLote: "",
    idContenedor: "",
    categoria: "Mezcal Artesanal",
    clase: "Joven / Blanco (Mezcla)",
    ingredientes: "",
    tipoMaguey: "",
    noAnalisis: "",
    observaciones: ""
  });

  // Modales adicionales solicitados para Granel
  const [isTrasladoModalOpen, setIsTrasladoModalOpen] = useState(false);
  const [trasladoForm, setTrasladoForm] = useState({
    id_granel_origen: "",
    no_lote_origen: "",
    instalacion_origen: "",
    volumen_disponible: 0,
    id_unidad_produccion_destino: "",
    instalacion_destino: "",
    no_tanque_destino: "",
    litros_traslado: "",
    fecha: new Date().toISOString().split('T')[0],
    folio_documento: "",
    observaciones: ""
  });

  const [isDilucionModalOpen, setIsDilucionModalOpen] = useState(false);
  const [dilucionForm, setDilucionForm] = useState({
    id_granel_origen: "",
    no_lote_origen: "",
    volumen_actual: 0,
    grado_actual: 0,
    grado_objetivo: 45.0,
    agua_agregada: 0,
    volumen_final: 0,
    no_tanque: "",
    lote_agua: "",
    fecha: new Date().toISOString().split('T')[0],
    observaciones: ""
  });

  const [isBajaModalOpen, setIsBajaModalOpen] = useState(false);
  const [bajaForm, setBajaForm] = useState({
    id_granel_origen: "",
    no_lote_origen: "",
    volumen_actual: 0,
    litros_baja: "",
    motivo: "Merma natural por evaporación en tanque",
    folio_documento: "",
    fecha: new Date().toISOString().split('T')[0],
    observaciones: ""
  });

  const [isMuestreoModalOpen, setIsMuestreoModalOpen] = useState(false);
  const [muestreoForm, setMuestreoForm] = useState({
    id_granel_origen: "",
    no_lote_origen: "",
    volumen_actual: 0,
    litros_muestra: 1.5,
    tipo_muestreo: "Muestreo Oficial NOM-070 (Tercio de muestra: ensayo, testigo socio, testigo UI)",
    laboratorio_inspector: "",
    folio_documento: "",
    fecha: new Date().toISOString().split('T')[0],
    observaciones: ""
  });

  // Estado para Modal de Movimientos y Trazabilidad (UI y Asociado)
  const [isMovimientosModalOpen, setIsMovimientosModalOpen] = useState(false);
  const [selectedLoteForMovimientos, setSelectedLoteForMovimientos] = useState(null);
  const [movimientosFilterTab, setMovimientosFilterTab] = useState("todos");
  const [movimientosStatusFilter, setMovimientosStatusFilter] = useState("todos");

  const handleOpenMovimientosModal = (rec = null) => {
    setSelectedLoteForMovimientos(rec);
    setMovimientosFilterTab("todos");
    setMovimientosStatusFilter("todos");
    setIsMovimientosModalOpen(true);
  };

  const handleOpenTraslado = (rec = null) => {
    const selectedG = rec || (granelRecords && granelRecords[0]) || null;
    const vDisp = selectedG ? (parseFloat(String(selectedG.invFinalVol ?? selectedG.saldoFinal ?? selectedG.volFinal ?? selectedG.volumen ?? selectedG.litros ?? selectedG.litrosTotal ?? selectedG.entradaVolumen ?? 0).replace(/[^\d.]/g, '')) || 0) : 0;
    const origInstId = selectedG?.id_unidad_produccion || selectedG?.id_anexo_cliente || "";
    let instOrig = selectedG?.instalacion || selectedG?.instalacionOrigen || "";
    if (!instOrig || instOrig === "Instalación Principal") {
      const foundOrig = availableInstalaciones.find(i => String(i.idanexocliente || i.id) === String(origInstId));
      if (foundOrig) {
        instOrig = foundOrig.informaciongeneralinstalacioncliente?.alias || foundOrig.alias;
      }
    }
    instOrig = instOrig || availableInstalaciones[0]?.alias || "Instalación Principal";
    const optVal = selectedG ? String(selectedG.id ?? selectedG.dbId ?? selectedG.id_bitacora_granel ?? selectedG.noLote ?? selectedG.no_lote ?? "") : "";

    setTrasladoForm({
      id_granel_origen: optVal,
      no_lote_origen: selectedG?.noLote || selectedG?.no_lote || "",
      id_unidad_produccion_origen: origInstId,
      instalacion_origen: instOrig,
      volumen_disponible: vDisp,
      id_unidad_produccion_destino: "",
      instalacion_destino: "",
      tipo_instalacion_destino: "",
      no_tanque_destino: "",
      litros_traslado: "",
      fecha: new Date().toISOString().split('T')[0],
      folio_documento: "",
      observaciones: ""
    });
    setIsTrasladoModalOpen(true);
  };

  const handleOpenDilucion = (rec = null) => {
    const selectedG = rec || (granelRecords && granelRecords[0]) || null;
    const vDisp = selectedG ? (parseFloat(String(selectedG.invFinalVol ?? selectedG.saldoFinal ?? selectedG.volFinal ?? selectedG.volumen ?? selectedG.litros ?? selectedG.litrosTotal ?? selectedG.entradaVolumen ?? 0).replace(/[^\d.]/g, '')) || 0) : 0;
    const aDisp = selectedG ? (parseFloat(String(selectedG.porcentaje_alc_vol ?? selectedG.invFinalAlc ?? selectedG.alcFinal ?? selectedG.entradaAlc ?? 0).replace(/[^\d.]/g, '')) || 0) : 48.0;
    const optVal = selectedG ? String(selectedG.id ?? selectedG.dbId ?? selectedG.id_bitacora_granel ?? selectedG.noLote ?? selectedG.no_lote ?? "") : "";

    setDilucionForm({
      id_granel_origen: optVal,
      no_lote_origen: selectedG?.noLote || selectedG?.no_lote || "",
      volumen_actual: vDisp,
      grado_actual: aDisp,
      agua_agregada: "",
      grado_objetivo: aDisp,
      volumen_final: vDisp,
      no_tanque: selectedG?.idContenedor || selectedG?.no_tanque || "TANQUE-01",
      lote_agua: "",
      fecha: new Date().toISOString().split('T')[0],
      observaciones: ""
    });
    setIsDilucionModalOpen(true);
  };

  const handleOpenBaja = (rec = null) => {
    const selectedG = rec || (granelRecords && granelRecords[0]) || null;
    const vDisp = selectedG ? (parseFloat(String(selectedG.invFinalVol ?? selectedG.saldoFinal ?? selectedG.volFinal ?? selectedG.volumen ?? selectedG.litros ?? selectedG.litrosTotal ?? selectedG.entradaVolumen ?? 0).replace(/[^\d.]/g, '')) || 0) : 0;
    const optVal = selectedG ? String(selectedG.id ?? selectedG.dbId ?? selectedG.id_bitacora_granel ?? selectedG.noLote ?? selectedG.no_lote ?? "") : "";

    setBajaForm({
      id_granel_origen: optVal,
      no_lote_origen: selectedG?.noLote || selectedG?.no_lote || "",
      volumen_actual: vDisp,
      litros_baja: "",
      motivo: "Merma natural por evaporación en tanque",
      folio_documento: "",
      fecha: new Date().toISOString().split('T')[0],
      observaciones: ""
    });
    setIsBajaModalOpen(true);
  };

  const handleOpenMuestreo = (rec = null) => {
    const selectedG = rec || (granelRecords && granelRecords[0]) || null;
    const vDisp = selectedG ? (parseFloat(String(selectedG.invFinalVol ?? selectedG.saldoFinal ?? selectedG.volFinal ?? selectedG.volumen ?? selectedG.litros ?? selectedG.litrosTotal ?? selectedG.entradaVolumen ?? 0).replace(/[^\d.]/g, '')) || 0) : 0;
    const optVal = selectedG ? String(selectedG.id ?? selectedG.dbId ?? selectedG.id_bitacora_granel ?? selectedG.noLote ?? selectedG.no_lote ?? "") : "";

    setMuestreoForm({
      id_granel_origen: optVal,
      no_lote_origen: selectedG?.noLote || selectedG?.no_lote || "",
      volumen_actual: vDisp,
      litros_muestra: 1.5,
      tipo_muestreo: "Muestreo Oficial NOM-070 (Tercio de muestra: ensayo, testigo socio, testigo UI)",
      laboratorio_inspector: "",
      folio_documento: "",
      fecha: new Date().toISOString().split('T')[0],
      observaciones: ""
    });
    setIsMuestreoModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Captura manual de No. de Lote nuevo para envasado
  const handleLoteSelect = (e) => {
    const selectedNoLote = e.target.value;
    setFormData(prev => ({
      ...prev,
      noLote: selectedNoLote,
      no_lote: selectedNoLote
    }));
  };

  // Solo se puede editar la Identificación del Mezcal y Contenedor (Imagen 1)
  const handleEditRecord = (rec) => {
    const vol = String(rec.litros ?? rec.invFinalVol ?? rec.entradaVolumen ?? "0").replace(/[^\d.]/g, '');
    const alc = String(rec.porcentaje_alc_vol ?? rec.invFinalAlc ?? rec.entradaAlc ?? "0").replace(/[^\d.]/g, '');
    setFormData({
      id: rec.id,
      fechaMovimiento: rec.fechaMovimiento || rec.fecha || new Date().toISOString().split('T')[0],
      fecha: rec.fecha || rec.fechaMovimiento || new Date().toISOString().split('T')[0],
      idContenedor: rec.idContenedor || rec.no_tanque || "",
      no_tanque: rec.no_tanque || rec.idContenedor || "",
      noLote: rec.noLote || rec.no_lote || rec.noProduccion || "",
      no_lote: rec.no_lote || rec.noLote || rec.noProduccion || "",
      categoria: rec.categoria || "Mezcal Artesanal",
      clase: rec.clase || "Blanco Joven",
      ingredientes: rec.ingredientes || rec.ingrediente || "",
      ingrediente: rec.ingrediente || rec.ingredientes || "",
      tipoMaguey: rec.tipoMaguey || rec.especie || "",
      especie: rec.especie || rec.tipoMaguey || "",
      noAnalisis: rec.noAnalisisFisicoquimico || rec.noAnalisis || rec.clave_fq || "",
      clave_fq: rec.clave_fq || rec.noAnalisisFisicoquimico || rec.noAnalisis || "",
      litros: vol,
      porcentaje_alc_vol: alc,
      invInicialVol: String(rec.invInicialVol || vol).replace(/[^\d.]/g, ''),
      invInicialAlc: String(rec.invInicialAlc || alc).replace(/[^\d.]/g, ''),
      entradaProcedencia: rec.entradaProcedencia || "",
      entradaVolumen: vol,
      entradaAlc: alc,
      salidaDestino: rec.salidaDestino || "",
      salidaVolumen: String(rec.salidaVolumen || "0").replace(/[^\d.]/g, ''),
      salidaAlc: String(rec.salidaAlc || "0").replace(/[^\d.]/g, ''),
      invFinalVol: vol,
      invFinalAlc: alc,
      observaciones: rec.observaciones || "",
      status: rec.status || "borrador"
    });
    setIsFormOpen(true);
  };

  // Función auxiliar: Formato Nombre Común (Nombre Científico)
  const formatMagueyNombreComunPrimero = (magueyStr, catalog = []) => {
    if (!magueyStr || typeof magueyStr !== 'string') return "";
    const trimmed = magueyStr.trim();
    if (!trimmed) return "";

    const stripAccents = (str) =>
      (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

    const cleanTerm = stripAccents(trimmed);
    const catList = Array.isArray(catalog) ? catalog : [];

    // Helper para verificar si un término incluye la palabra de otro (ignorando "maguey" y "agave")
    const containsWord = (source, target) => {
      if (!source || !target) return false;
      const words = target.split(/\s+/).filter(w => w.length > 2 && w !== "maguey" && w !== "agave");
      if (words.length === 0) return source.includes(target);
      return words.every(w => source.includes(w));
    };

    // 1. Si ya viene con formato "Nombre Común (Nombre Científico)" o viceversa
    const match = trimmed.match(/^([^(]+)\s*\(([^)]+)\)$/);
    if (match) {
      let p1 = match[1].trim();
      let p2 = match[2].trim();
      let commonPart = p1;
      let scientificPart = p2;

      if (p1.toLowerCase().includes("agave")) {
        commonPart = p2;
        scientificPart = p1;
      }

      const cleanCommon = stripAccents(commonPart);

      // Buscar si el nombre común coincide con alguna especie en el catálogo para normalizar
      const matchedCat = catList.find(c => {
        const cComun = stripAccents(c.nombre_comun || c.nombreComun);
        return cComun && (cComun === cleanCommon || containsWord(cleanCommon, cComun) || containsWord(cComun, cleanCommon));
      });

      const cleanStr = (s) => (s || "").replace(/\s+/g, " ").trim();
      if (matchedCat && matchedCat.nombre_comun && matchedCat.nombre_cientifico) {
        return `${cleanStr(matchedCat.nombre_comun)} (${cleanStr(matchedCat.nombre_cientifico)})`;
      }

      return `${cleanStr(commonPart)} (${cleanStr(scientificPart)})`;
    }

    const cleanStr = (s) => (s || "").replace(/\s+/g, " ").trim();

    // 2. Coincidencia EXACTA por nombre común en el catálogo
    const exactCommonMatch = catList.find(c => {
      const cComun = stripAccents(c.nombre_comun || c.nombreComun);
      return cComun && cComun === cleanTerm;
    });
    if (exactCommonMatch && exactCommonMatch.nombre_comun && exactCommonMatch.nombre_cientifico) {
      return `${cleanStr(exactCommonMatch.nombre_comun)} (${cleanStr(exactCommonMatch.nombre_cientifico)})`;
    }

    // 3. Coincidencia PARCIAL por nombre común en el catálogo (ej: "espadin" -> "MAGUEY ESPADÍN")
    const partialCommonMatch = catList.find(c => {
      const cComun = stripAccents(c.nombre_comun || c.nombreComun);
      return cComun && (containsWord(cleanTerm, cComun) || containsWord(cComun, cleanTerm));
    });
    if (partialCommonMatch && partialCommonMatch.nombre_comun && partialCommonMatch.nombre_cientifico) {
      return `${cleanStr(partialCommonMatch.nombre_comun)} (${cleanStr(partialCommonMatch.nombre_cientifico)})`;
    }

    // 4. Si el término ingresado es estrictamente un nombre científico de Agave (ej. "Agave angustifolia")
    if (cleanTerm.startsWith("agave")) {
      const scientMatch = catList.find(c => {
        const cCient = stripAccents(c.nombre_cientifico || c.nombreCientifico);
        return cCient && (cCient === cleanTerm || cleanTerm.includes(cCient));
      });
      if (scientMatch && scientMatch.nombre_comun && scientMatch.nombre_cientifico) {
        return `${cleanStr(scientMatch.nombre_comun)} (${cleanStr(scientMatch.nombre_cientifico)})`;
      }
    }

    return trimmed;
  };

  // Manejo de Fusión / Mezcla / Extracción Parcial de Lotes de Granel

  const filteredRecords = useMemo(() => {
    return (granelRecords || []).filter(rec => {
      // Excluir lotes sin saldo (saldo <= 0)
      const saldoFinalNum = parseFloat(String(rec.invFinalVol ?? rec.volFinal ?? rec.saldoFinal ?? rec.litros ?? rec.litrosTotal ?? 0).replace(/[^\d.]/g, '')) || 0;
      if (saldoFinalNum <= 0) return false;

      const term = search.toLowerCase();
      const matchSearch =
        (rec.noLote && String(rec.noLote).toLowerCase().includes(term)) ||
        (rec.idContenedor && String(rec.idContenedor).toLowerCase().includes(term)) ||
        (rec.categoria && String(rec.categoria).toLowerCase().includes(term)) ||
        (rec.clase && String(rec.clase).toLowerCase().includes(term)) ||
        (rec.tipoMaguey && String(rec.tipoMaguey).toLowerCase().includes(term)) ||
        (rec.marca && String(rec.marca).toLowerCase().includes(term)) ||
        (rec.hologramas && String(rec.hologramas).toLowerCase().includes(term)) ||
        (getInstalacionAlias(rec) && String(getInstalacionAlias(rec)).toLowerCase().includes(term)) ||
        (rec.inspector && String(rec.inspector).toLowerCase().includes(term));

      const rawSt = String(rec.status || rec.statusUI || '').toLowerCase();
      let matchStatus = true;
      if (statusFilter !== "todos") {
        if (statusFilter === "aprobado") matchStatus = rawSt.includes("aprobad") || rawSt.includes("aceptad");
        else if (statusFilter === "enviada") matchStatus = rawSt.includes("enviad") || rawSt.includes("revision") || rawSt.includes("pendiente");
        else if (statusFilter === "borrador") matchStatus = rawSt.includes("borrador");
        else if (statusFilter === "rechazado") matchStatus = rawSt.includes("rechazad");
        else if (statusFilter === "cancelado") matchStatus = rawSt.includes("cancelad");
      }

      let matchClase = true;
      if (claseFilter !== "todos") {
        const cl = String(rec.clase || '').toLowerCase();
        if (claseFilter === "joven") matchClase = cl.includes("joven") || cl.includes("blanco");
        else if (claseFilter === "reposado") matchClase = cl.includes("reposado");
        else if (claseFilter === "anejo") matchClase = cl.includes("añejo") || cl.includes("anejo");
        else if (claseFilter === "madurado_vidrio") matchClase = cl.includes("vidrio") || cl.includes("madurado");
        else if (claseFilter === "abocado") matchClase = cl.includes("abocado");
        else if (claseFilter === "destilado_con") matchClase = cl.includes("destilado con");
      }

      let matchTipo = true;
      if (tipoGranelFilter === "granel") matchTipo = esGranelRegular(rec);
      else if (tipoGranelFilter === "maduracion") matchTipo = esGranelMaduracion(rec);
      else if (tipoGranelFilter === "producto_terminado") matchTipo = esProductoTerminado(rec);

      return matchSearch && matchStatus && matchClase && matchTipo;
    });
  }, [granelRecords, search, statusFilter, claseFilter, tipoGranelFilter]);

  return (
    <div className="animate-fadeIn">
      {/* =========================================================================
          1. HEADER DE HISTORIAL Y CONTROLES DE FILTRADO
      ========================================================================= */}
      <div className="destilacion-toolbar-container" style={{ borderColor: "#A7F3D0" }}>
        <div className="destilacion-toolbar-top">
          <div className="destilacion-toolbar-title-box">
            <h2>
              <Inventory2Icon style={{ color: "#059669", fontSize: 24 }} />
              Inventarios de Mezcal a Granel (Sección II)
            </h2>
            <p>
              Inventario final, custodia en contenedores, kardex de entradas/salidas y fusiones/mezclas de producto terminado
            </p>
          </div>

          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => setIsFusionModalOpen(true)}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", background: "#F5F3FF", color: "#7C3AED", border: "1px solid #DDD6FE", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
            >
              <MergeTypeIcon style={{ fontSize: 18 }} />
              <span>Fusión / Extracción</span>
            </button>

            <button
              type="button"
              onClick={() => handleOpenMovimientosModal()}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", background: "#CCFBF1", color: "#0F766E", border: "1px solid #99F6E4", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
              title="Historial de Movimientos y Estatus de Aprobación UI"
            >
              <HistoryIcon style={{ fontSize: 18 }} />
              <span>Movimientos</span>
            </button>

            <button
              type="button"
              onClick={() => handleOpenTraslado()}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#EFF6FF", color: "#1D4ED8", border: "1px solid #BFDBFE", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
              title="Trasladar mezcal a granel a otra instalación registrada"
            >
              <LocalShippingIcon style={{ fontSize: 18 }} />
              <span>Traslado Instalaciones</span>
            </button>

            <button
              type="button"
              onClick={() => handleOpenDilucion()}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#F0FDFA", color: "#0D9488", border: "1px solid #99F6E4", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
              title="Ajuste o dilución de grado alcohólico con agua"
            >
              <OpacityIcon style={{ fontSize: 18 }} />
              <span>Ajuste / Dilución</span>
            </button>

            <button
              type="button"
              onClick={() => handleOpenBaja()}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#FFFBEB", color: "#D97706", border: "1px solid #FDE68A", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
              title="Salida o baja de producto por merma, evaporación, desecho o venta"
            >
              <TrendingDownIcon style={{ fontSize: 18 }} />
              <span>Baja / Merma</span>
            </button>

            <button
              type="button"
              onClick={() => handleOpenMuestreo()}
              className="btn-secondary-custom"
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 14px", background: "#EEF2FF", color: "#4F46E5", border: "1px solid #C7D2FE", borderRadius: "12px", fontWeight: 700, fontSize: "12.5px" }}
              title="Salida a muestreo para análisis de laboratorio o UI"
            >
              <BiotechIcon style={{ fontSize: 18 }} />
              <span>Muestreo</span>
            </button>

            <button
              type="button"
              onClick={() => {
                const today = new Date().toISOString().split('T')[0];
                const defInst = envasadoInstalaciones[0];
                const defInstId = defInst ? (defInst.idanexocliente || defInst.id) : "";
                const defAlias = defInst ? (defInst.informaciongeneralinstalacioncliente?.alias || defInst.alias || "") : "";
                setFormData({
                  id: null,
                  fechaMovimiento: today,
                  fecha: today,
                  id_unidad_produccion: defInstId,
                  id_anexo_cliente: defInstId,
                  instalacion: defAlias,
                  instalacionOrigen: defAlias,
                  idContenedor: "",
                  no_tanque: "",
                  noLote: "",
                  no_lote: "",
                  categoria: "Mezcal Artesanal",
                  clase: "Blanco Joven",
                  especie: "",
                  tipoMaguey: "",
                  ingrediente: "",
                  ingredientes: "",
                  clave_fq: "",
                  noAnalisis: "",
                  litros: "",
                  porcentaje_alc_vol: "",
                  invInicialVol: "0",
                  invInicialAlc: "0",
                  entradaProcedencia: "Ingreso a Almacén",
                  entradaVolumen: "0",
                  entradaAlc: "0",
                  salidaDestino: "",
                  salidaVolumen: "0",
                  salidaAlc: "0",
                  invFinalVol: "0",
                  invFinalAlc: "0",
                  observaciones: "Ingreso a inventario de tanques de mezcal a granel en almacén.",
                  origen_registro: "manual",
                  status: "borrador"
                });
                setIsFormOpen(true);
              }}
              className="destilacion-btn-new"
              style={{ background: "linear-gradient(135deg, #059669 0%, #10B981 100%)", boxShadow: "0 4px 14px rgba(5, 150, 105, 0.3)" }}
            >
              <AddIcon style={{ fontSize: 18 }} />
              <span>Nuevo Movimiento a Granel</span>
            </button>

            <button
              type="button"
              onClick={handleRefresh}
              disabled={isRefreshing}
              className={`btn-refresh-granel ${isRefreshing ? "spinning" : ""}`}
              title="Sincronizar y actualizar tabla con los últimos registros de la Unidad de Inspección"
            >
              <RefreshIcon className="refresh-icon" style={{ fontSize: 18 }} />
              <span>{isRefreshing ? "Actualizando..." : "Actualizar Tabla"}</span>
            </button>
          </div>
        </div>

        {/* BOTONES DE FILTRO RÁPIDO: GRANEL | GRANEL DE MADURACIÓN | PRODUCTO TERMINADO */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 14px",
          background: "#F8FAFC",
          borderRadius: "12px",
          margin: "14px 0 12px 0",
          border: "1px solid #E2E8F0",
          flexWrap: "wrap"
        }}>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#475569", marginRight: "4px" }}>
            Tipo de inventario:
          </span>

          <button
            type="button"
            onClick={() => setTipoGranelFilter("todos")}
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.2s ease",
              border: tipoGranelFilter === "todos" ? "1.5px solid #059669" : "1px solid #CBD5E1",
              background: tipoGranelFilter === "todos" ? "#ECFDF5" : "#FFFFFF",
              color: tipoGranelFilter === "todos" ? "#065F46" : "#475569",
              boxShadow: tipoGranelFilter === "todos" ? "0 2px 6px rgba(5, 150, 105, 0.15)" : "none"
            }}
          >
            📋 Todos ({countsByTipo.todos})
          </button>

          <button
            type="button"
            onClick={() => setTipoGranelFilter("granel")}
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.2s ease",
              border: tipoGranelFilter === "granel" ? "1.5px solid #0D9488" : "1px solid #CBD5E1",
              background: tipoGranelFilter === "granel" ? "#F0FDFA" : "#FFFFFF",
              color: tipoGranelFilter === "granel" ? "#0F766E" : "#475569",
              boxShadow: tipoGranelFilter === "granel" ? "0 2px 6px rgba(13, 148, 136, 0.15)" : "none"
            }}
          >
            🛢️ Granel ({countsByTipo.granel})
          </button>

          <button
            type="button"
            onClick={() => setTipoGranelFilter("maduracion")}
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.2s ease",
              border: tipoGranelFilter === "maduracion" ? "1.5px solid #D97706" : "1px solid #CBD5E1",
              background: tipoGranelFilter === "maduracion" ? "#FFFBEB" : "#FFFFFF",
              color: tipoGranelFilter === "maduracion" ? "#92400E" : "#475569",
              boxShadow: tipoGranelFilter === "maduracion" ? "0 2px 6px rgba(217, 119, 6, 0.15)" : "none"
            }}
          >
            🪵 Granel de Maduración ({countsByTipo.maduracion})
          </button>

          <button
            type="button"
            onClick={() => setTipoGranelFilter("producto_terminado")}
            style={{
              padding: "6px 16px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.2s ease",
              border: tipoGranelFilter === "producto_terminado" ? "1.5px solid #7C3AED" : "1px solid #CBD5E1",
              background: tipoGranelFilter === "producto_terminado" ? "#F5F3FF" : "#FFFFFF",
              color: tipoGranelFilter === "producto_terminado" ? "#6D28D9" : "#475569",
              boxShadow: tipoGranelFilter === "producto_terminado" ? "0 2px 6px rgba(124, 58, 237, 0.2)" : "none"
            }}
          >
            🍾 Producto Terminado ({countsByTipo.terminado})
          </button>
        </div>

        <div className="destilacion-toolbar-controls">
          {/* Búsqueda */}
          <div className="destilacion-search-box">
            <SearchIcon className="destilacion-search-icon" style={{ color: "#059669" }} />
            <input
              type="text"
              placeholder="Buscar por contenedor, lote, clase, maguey..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button
                type="button"
                className="destilacion-search-clear"
                onClick={() => setSearch("")}
                title="Limpiar búsqueda"
              >
                <CloseIcon style={{ fontSize: 14 }} />
              </button>
            )}
          </div>

          {/* Filtro por estado */}
          <div className="destilacion-filter-wrapper">
            <FilterListIcon className="destilacion-filter-icon" style={{ color: "#059669" }} />
            <select
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
              className="destilacion-filter-select"
            >
              <option value="todos">Todos los Estados</option>
              <option value="aprobado">Aceptadas por UI</option>
              <option value="enviada">Enviadas / En Revisión</option>
              <option value="borrador">Borradores</option>
              <option value="rechazado">Rechazadas (Corrección)</option>
              <option value="cancelado">Canceladas</option>
            </select>
          </div>

          {/* Filtro por clase */}
          <div className="destilacion-filter-wrapper">
            <LocalDrinkIcon className="destilacion-filter-icon" style={{ color: "#059669" }} />
            <select
              value={claseFilter}
              onChange={e => setClaseFilter(e.target.value)}
              className="destilacion-filter-select"
            >
              <option value="todos">Todas las Clases</option>
              <option value="joven">Joven / Blanco</option>
              <option value="reposado">Reposado</option>
              <option value="anejo">Añejo</option>
              <option value="madurado_vidrio">Madurado en Vidrio</option>
              <option value="abocado">Abocado con</option>
              <option value="destilado_con">Destilado con</option>
            </select>
          </div>

          {/* Botón Reset */}
          {(search || statusFilter !== "todos" || claseFilter !== "todos" || tipoGranelFilter !== "todos") && (
            <button
              type="button"
              className="destilacion-btn-reset"
              onClick={() => {
                setSearch("");
                setStatusFilter("todos");
                setClaseFilter("todos");
                setTipoGranelFilter("todos");
              }}
              title="Restablecer filtros"
            >
              <CloseIcon style={{ fontSize: 15 }} />
              <span>Limpiar Filtros</span>
            </button>
          )}

          {/* Botón Refrescar Rápido */}
          <button
            type="button"
            onClick={handleRefresh}
            disabled={isRefreshing}
            className={`destilacion-btn-reset ${isRefreshing ? "spinning" : ""}`}
            style={{
              background: "#F0FDFA",
              color: "#0F766E",
              border: "1px solid #99F6E4",
              fontWeight: 700,
              cursor: isRefreshing ? "not-allowed" : "pointer"
            }}
            title="Refrescar datos de la tabla"
          >
            <RefreshIcon className="refresh-icon" style={{ fontSize: 16 }} />
            <span>{isRefreshing ? "Cargando..." : "Refrescar"}</span>
          </button>
        </div>
      </div>

      {/* =========================================================================
          2. TABLA HISTÓRICA DE INVENTARIO A GRANEL
      ========================================================================= */}
      <div className="table-responsive-container">
        <table className="custom-table-bitacora">
          <thead>
            <tr>
              <th>Fecha Mov.</th>
              <th>Instalación</th>
              <th>Lote / Contenedor</th>
              <th>Categoría / Clase</th>
              <th>Nº Análisis</th>
              <th>Saldo Final</th>
              <th>Inspector Asignado</th>
              <th>Estatus UI</th>
              <th style={{ textAlign: "center" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredRecords.length === 0 ? (
              <tr>
                <td colSpan="9" className="empty-table-cell" style={{ textAlign: "center", padding: "36px", color: "var(--text-muted)" }}>
                  <Inventory2Icon style={{ fontSize: 44, opacity: 0.35, color: "#059669", marginBottom: "8px" }} />
                  <p style={{ margin: 0, fontWeight: 600 }}>No hay registros de inventario a granel disponibles.</p>
                </td>
              </tr>
            ) : (
              filteredRecords.map((rec, idx) => {
                const volFinalNum = parseFloat(String(rec.invFinalVol || rec.volFinal || 0).replace(/[^\d.]/g, '')) || 0;
                const alcFinalNum = parseFloat(String(rec.invFinalAlc || rec.alcFinal || 0).replace(/[^\d.]/g, '')) || 0;

                return (
                  <tr key={rec.id || idx}>
                    <td style={{ fontWeight: 600 }}>{rec.fechaMovimiento || "-"}</td>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <ApartmentIcon style={{ fontSize: 16, color: "#2563EB", flexShrink: 0 }} />
                        <span style={{ fontWeight: 600, color: "#1E293B", fontSize: "12.5px" }} title={getInstalacionAlias(rec)}>
                          {getInstalacionAlias(rec)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <strong style={{ color: "#059669", fontSize: "13.5px" }}>Lote: {rec.noLote || rec.noProduccion || "-"}</strong>
                        <span style={{ fontSize: "11.5px", color: "var(--text-muted)" }}>{rec.idContenedor || "-"}</span>
                        {Number(rec.botellas) > 0 && (
                          <span style={{ fontSize: "10.5px", color: "#6D28D9", fontWeight: 700, marginTop: "2px", background: "#F5F3FF", border: "1px solid #DDD6FE", padding: "1px 6px", borderRadius: "4px", width: "fit-content" }}>
                            🍾 {Number(rec.botellas).toLocaleString()} botellas {Number(rec.cajas) > 0 ? `(${Number(rec.cajas).toLocaleString()} cjs)` : ''}
                          </span>
                        )}
                        {esGranelMaduracion(rec) && (
                          <span style={{ fontSize: "10.5px", color: "#92400E", fontWeight: 700, marginTop: "2px", background: "#FFFBEB", border: "1px solid #FDE68A", padding: "1px 6px", borderRadius: "4px", width: "fit-content" }}>
                            🪵 Maduración {rec.no_barricas || rec.noBarricas ? `(${rec.no_barricas || rec.noBarricas})` : ''}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        <strong style={{ color: "var(--text-primary)" }}>{rec.categoria || "Mezcal"}</strong>
                        <div style={{ fontSize: "11.5px", color: "#64748B" }}>{rec.clase || "Blanco Joven"}</div>
                        {rec.marca && (
                          <div style={{ fontSize: "11px", color: "#6D28D9", fontWeight: 700, marginTop: 1 }}>
                            🏷️ {rec.marca}
                          </div>
                        )}
                        {rec.hologramas && (
                          <div style={{ fontSize: "10px", color: "#64748B", fontFamily: "monospace", marginTop: 1 }}>
                            Folios: {rec.hologramas}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <span style={{ fontSize: "12px", fontFamily: "monospace", background: "#F1F5F9", padding: "2px 6px", borderRadius: "6px" }}>
                        {rec.noAnalisisFisicoquimico || rec.noAnalisis || "-"}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <strong style={{ color: "#059669", fontSize: "14px" }}>{volFinalNum.toLocaleString()} L</strong>
                        <span style={{ fontSize: "11px", color: "var(--text-muted)" }}>@ {alcFinalNum}% Alc.</span>
                        {(() => {
                          const movs = Array.isArray(rec.movimientos) ? rec.movimientos : [];
                          const obsStr = String(rec.observaciones || "");

                          const isDilApproved = Boolean(movs.some(m => m.tipo_movimiento === "dilucion" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[DILUCIÓN APROBADA POR UI]"));
                          const pendingDil = !isDilApproved ? (rec.dilucionPendiente || movs.find(m => m.tipo_movimiento === "dilucion" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente")))))) : null;
                          const hasPending = Boolean(!isDilApproved && (rec.tieneDilucionPendiente || pendingDil || (!obsStr.includes("[DILUCIÓN APROBADA POR UI]") && obsStr.includes("[SOLICITUD DILUCIÓN PENDIENTE UI]"))));
                          if (hasPending) {
                            const aguaL = pendingDil ? parseFloat(pendingDil.agua_agregada || 0) : null;
                            return (
                              <span style={{ fontSize: "10px", color: "#0F766E", fontWeight: 800, marginTop: "2px", background: "#CCFBF1", padding: "1px 5px", borderRadius: "4px", width: "fit-content" }} title="Dilución pendiente de validación UI">
                                💧 Dilución: {aguaL ? `+${aguaL} L` : "En revisión"}
                              </span>
                            );
                          }
                          if (isDilApproved) {
                            return (
                              <span style={{ fontSize: "10px", color: "#047857", fontWeight: 700, marginTop: "2px", background: "#D1FAE5", padding: "1px 5px", borderRadius: "4px", width: "fit-content" }} title="Dilución dictaminada y aplicada oficialmente">
                                💧 Dilución aplicada
                              </span>
                            );
                          }

                          const isBajaApproved = Boolean(movs.some(m => (m.tipo_movimiento === "baja" || m.tipo_movimiento === "salida") && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[BAJA APROBADA POR UI]"));
                          const pendingBaja = !isBajaApproved ? (rec.bajaPendiente || movs.find(m => (m.tipo_movimiento === "baja" || m.tipo_movimiento === "salida") && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente")))))) : null;
                          const hasPendingBaja = Boolean(!isBajaApproved && (rec.tieneBajaPendiente || pendingBaja || (!obsStr.includes("[BAJA APROBADA POR UI]") && obsStr.includes("[SOLICITUD BAJA PENDIENTE UI]"))));
                          if (hasPendingBaja) {
                            const volB = pendingBaja ? parseFloat(pendingBaja.litros_transferidos || 0) : null;
                            return (
                              <span style={{ fontSize: "10px", color: "#C2410C", fontWeight: 800, marginTop: "2px", background: "#FFEDD5", padding: "1px 5px", borderRadius: "4px", width: "fit-content" }} title="Baja de volumen pendiente de dictamen UI">
                                📦 Baja: {volB ? `-${volB} L` : "En revisión"}
                              </span>
                            );
                          }

                          const isMuesApproved = Boolean(movs.some(m => m.tipo_movimiento === "muestreo" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[MUESTREO APROBADO POR UI]"));
                          const pendingMues = !isMuesApproved ? (rec.muestreoPendiente || movs.find(m => m.tipo_movimiento === "muestreo" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente")))))) : null;
                          const hasPendingMues = Boolean(!isMuesApproved && (rec.tieneMuestreoPendiente || pendingMues || (!obsStr.includes("[MUESTREO APROBADO POR UI]") && obsStr.includes("[SOLICITUD MUESTREO PENDIENTE UI]"))));
                          if (hasPendingMues) {
                            const volM = pendingMues ? parseFloat(pendingMues.litros_transferidos || 0) : null;
                            return (
                              <span style={{ fontSize: "10px", color: "#4338CA", fontWeight: 800, marginTop: "2px", background: "#EEF2FF", padding: "1px 5px", borderRadius: "4px", width: "fit-content" }} title="Extracción de muestra pendiente de dictamen UI">
                                🧪 Muestra: {volM ? `-${volM} L` : "En revisión"}
                              </span>
                            );
                          }

                          const isTrasApproved = Boolean(movs.some(m => m.tipo_movimiento === "traslado" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[TRASLADO APROBADO POR UI]"));
                          const pendingTras = !isTrasApproved ? (rec.trasladoPendiente || movs.find(m => m.tipo_movimiento === "traslado" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente")))))) : null;
                          const hasPendingTras = Boolean(!isTrasApproved && (rec.tieneTrasladoPendiente || pendingTras || (!obsStr.includes("[TRASLADO APROBADO POR UI]") && obsStr.includes("[SOLICITUD TRASLADO PENDIENTE UI]"))));
                          if (hasPendingTras) {
                            const volT = pendingTras ? parseFloat(pendingTras.litros_transferidos || 0) : null;
                            return (
                              <span style={{ fontSize: "10px", color: "#1D4ED8", fontWeight: 800, marginTop: "2px", background: "#EFF6FF", padding: "1px 5px", borderRadius: "4px", width: "fit-content" }} title="Traslado a otra instalación pendiente de dictamen UI">
                                🚛 Traslado: {volT ? `-${volT} L` : "En revisión"}
                              </span>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ fontSize: "14px" }}>👮‍♂️</span>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: (rec.inspector && rec.inspector !== 'Sin asignar' && !String(rec.inspector).includes('Pendiente')) ? '#0F766E' : '#64748B'
                          }}
                          title={rec.inspector || 'Pendiente de Asignación UI'}
                        >
                          {rec.inspector || 'Pendiente de Asignación UI'}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        {(() => {
                          const raw = String(rec.status || rec.statusUI || rec.estatus || 'borrador').toLowerCase();
                          let badgeClass = 'borrador';
                          let label = 'Borrador';

                          if (raw.includes('aprobad') || raw.includes('aceptad')) {
                            badgeClass = 'aprobado';
                            label = 'Aprobado por UI';
                          } else if (raw.includes('rechazad')) {
                            badgeClass = 'rechazado';
                            label = 'Rechazado';
                          } else if (raw.includes('revision') || raw.includes('enviad') || raw.includes('pendiente')) {
                            badgeClass = 'revision';
                            label = 'En Revisión UI';
                          } else if (raw.includes('cancelad')) {
                            badgeClass = 'cancelado';
                            label = 'Cancelado';
                          }

                          return (
                            <span className={`badge-status ${badgeClass}`}>
                              {label}
                            </span>
                          );
                        })()}

                        {/* Observaciones de corrección/rechazo de UI */}
                        {(() => {
                          const raw = String(rec.status || rec.statusUI || rec.estatus || '').toLowerCase();
                          const obsRechazo = rec.observaciones_correccion || rec.observacionesCorreccion || rec.observaciones_rechazo;
                          if (raw.includes('rechazad') && obsRechazo) {
                            return (
                              <span
                                style={{
                                  fontSize: "10.5px",
                                  background: "#FEF2F2",
                                  color: "#991B1B",
                                  border: "1px solid #FCA5A5",
                                  borderRadius: "6px",
                                  padding: "2px 6px",
                                  fontWeight: 600,
                                  lineHeight: 1.3,
                                  marginTop: "2px",
                                  display: "inline-block"
                                }}
                                title={`Motivo de rechazo UI: ${obsRechazo}`}
                              >
                                ⚠️ Motivo: {obsRechazo}
                              </span>
                            );
                          }
                          return null;
                        })()}
                        {(() => {
                          const movs = Array.isArray(rec.movimientos) ? rec.movimientos : [];
                          const obsStr = String(rec.observaciones || "");

                          const isDilApproved = Boolean(movs.some(m => m.tipo_movimiento === "dilucion" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[DILUCIÓN APROBADA POR UI]"));
                          const hasPendingDil = Boolean(!isDilApproved && (rec.tieneDilucionPendiente || movs.some(m => m.tipo_movimiento === "dilucion" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente"))))) || (!obsStr.includes("[DILUCIÓN APROBADA POR UI]") && obsStr.includes("[SOLICITUD DILUCIÓN PENDIENTE UI]"))));
                          if (hasPendingDil) {
                            return (
                              <span style={{ fontSize: "10px", background: "#FEF3C7", color: "#92400E", border: "1px solid #FCD34D", borderRadius: "6px", padding: "2px 6px", fontWeight: 800, whiteSpace: "nowrap" }} title="Solicitud de ajuste de agua en espera de dictamen UI">
                                ⏳ Revisión Dilución UI
                              </span>
                            );
                          }

                          const isBajaApproved = Boolean(movs.some(m => (m.tipo_movimiento === "baja" || m.tipo_movimiento === "salida") && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[BAJA APROBADA POR UI]"));
                          const hasPendingBaja = Boolean(!isBajaApproved && (rec.tieneBajaPendiente || movs.some(m => (m.tipo_movimiento === "baja" || m.tipo_movimiento === "salida") && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente"))))) || (!obsStr.includes("[BAJA APROBADA POR UI]") && obsStr.includes("[SOLICITUD BAJA PENDIENTE UI]"))));
                          if (hasPendingBaja) {
                            return (
                              <span style={{ fontSize: "10px", background: "#FFEDD5", color: "#C2410C", border: "1px solid #FDBA74", borderRadius: "6px", padding: "2px 6px", fontWeight: 800, whiteSpace: "nowrap" }} title="Solicitud de egreso/baja en espera de dictamen UI">
                                ⏳ Revisión Baja UI
                              </span>
                            );
                          }

                          const isMuesApproved = Boolean(movs.some(m => m.tipo_movimiento === "muestreo" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[MUESTREO APROBADO POR UI]"));
                          const hasPendingMues = Boolean(!isMuesApproved && (rec.tieneMuestreoPendiente || movs.some(m => m.tipo_movimiento === "muestreo" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente"))))) || (!obsStr.includes("[MUESTREO APROBADO POR UI]") && obsStr.includes("[SOLICITUD MUESTREO PENDIENTE UI]"))));
                          if (hasPendingMues) {
                            return (
                              <span style={{ fontSize: "10px", background: "#EEF2FF", color: "#4338CA", border: "1px solid #C7D2FE", borderRadius: "6px", padding: "2px 6px", fontWeight: 800, whiteSpace: "nowrap" }} title="Extracción de muestra en espera de dictamen UI">
                                ⏳ Revisión Muestra UI
                              </span>
                            );
                          }

                          const isTrasApproved = Boolean(movs.some(m => m.tipo_movimiento === "traslado" && (m.es_aprobado || m.estado_ui === "Aprobado por UI")) || obsStr.includes("[TRASLADO APROBADO POR UI]"));
                          const hasPendingTras = Boolean(!isTrasApproved && (rec.tieneTrasladoPendiente || movs.some(m => m.tipo_movimiento === "traslado" && (m.es_pendiente || (!m.es_aprobado && !m.es_rechazado && (String(m.motivo || "").toLowerCase().includes("pendiente") || String(m.observaciones || "").toLowerCase().includes("pendiente"))))) || (!obsStr.includes("[TRASLADO APROBADO POR UI]") && obsStr.includes("[SOLICITUD TRASLADO PENDIENTE UI]"))));
                          if (hasPendingTras) {
                            return (
                              <span style={{ fontSize: "10px", background: "#EFF6FF", color: "#1D4ED8", border: "1px solid #93C5FD", borderRadius: "6px", padding: "2px 6px", fontWeight: 800, whiteSpace: "nowrap" }} title="Solicitud de traslado en espera de dictamen UI">
                                ⏳ Revisión Traslado UI
                              </span>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "6px", justifyContent: "center", alignItems: "center" }}>
                        <button
                          type="button"
                          onClick={() => setSelectedRecord(rec)}
                          title="Ver Detalle Completo (Identificación e Inventarios)"
                          className="btn-action-icon view"
                        >
                          <VisibilityIcon style={{ fontSize: 16 }} />
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setDocumentosModalRecord(rec);
                            setIsDocumentosModalOpen(true);
                          }}
                          title="Expediente de Documentos (Análisis FQ, Certificado de Granel, Informe de Servicio)"
                          className="btn-action-icon"
                          style={{ color: "#0284C7", background: "#E0F2FE", border: "1px solid #BAE6FD" }}
                        >
                          <DescriptionIcon style={{ fontSize: 16 }} />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleOpenMovimientosModal(rec)}
                          title="Ver Movimientos y Estatus de este Lote"
                          className="btn-action-icon"
                          style={{ color: "#0F766E", background: "#F0FDFA", border: "1px solid #CCFBF1" }}
                        >
                          <HistoryIcon style={{ fontSize: 16 }} />
                        </button>

                        {String(rec.status || rec.statusUI || '').toLowerCase().includes('borrador') && handleUndoGranel && (
                          <button
                            type="button"
                            onClick={() => handleUndoGranel(rec)}
                            title="Deshacer Movimiento (Solo en Borrador) y Regresar Volumen"
                            className="btn-action-icon delete"
                          >
                            <UndoIcon style={{ fontSize: 16 }} />
                          </button>
                        )}

                        {(String(rec.status || rec.statusUI || rec.estatus || '').toLowerCase().includes('borrador') || String(rec.status || rec.statusUI || rec.estatus || '').toLowerCase().includes('rechaz')) && handleSaveGranel && (
                          <button
                            type="button"
                            onClick={() => handleSaveGranel(null, "revision", rec)}
                            title={String(rec.status || rec.statusUI || rec.estatus || '').toLowerCase().includes('rechaz') ? "Reenviar Lote a Revisión de Unidad de Inspección" : "Enviar Borrador a Revisión de Unidad de Inspección"}
                            className="btn-action-icon"
                            style={{ color: "#059669", background: "#ECFDF5", border: "1px solid #A7F3D0" }}
                          >
                            <SendIcon style={{ fontSize: 16 }} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Controles de Paginación */}
      {(() => {
        const totalRecs = Number(pagination?.total ?? (granelRecords?.length || 0));
        const effectiveLimit = Number(limit || pagination?.limit || 10);
        const totalPages = Number(pagination?.totalPages ?? Math.max(1, Math.ceil(totalRecs / effectiveLimit)));
        const pageNum = Number(currentPage || pagination?.page || 1);

        if (totalRecs <= 0 && (!granelRecords || granelRecords.length === 0)) return null;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "16px",
              marginBottom: "16px",
              padding: "12px 20px",
              background: "#FFFFFF",
              borderRadius: "12px",
              border: "1px solid #E2E8F0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              flexWrap: "wrap",
              gap: "14px"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <span style={{ fontSize: "13px", color: "var(--text-secondary, #64748B)", fontWeight: 500 }}>
                Mostrando página <strong>{pageNum}</strong> de <strong>{totalPages || 1}</strong> ({totalRecs} lotes en total)
              </span>

              {onLimitChange && (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#94A3B8" }}>Por página:</span>
                  <select
                    className="form-select form-select-sm"
                    value={effectiveLimit}
                    onChange={(e) => onLimitChange(Number(e.target.value))}
                    style={{
                      padding: "3px 24px 3px 8px",
                      fontSize: "12px",
                      borderRadius: "6px",
                      borderColor: "#CBD5E1",
                      backgroundColor: "#F8FAFC",
                      cursor: "pointer",
                      width: "auto"
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <button
                type="button"
                disabled={pageNum <= 1}
                onClick={() => onPageChange ? onPageChange(Math.max(1, pageNum - 1)) : (setCurrentPage && setCurrentPage(prev => Math.max(1, prev - 1)))}
                className="btn-secondary-custom"
                style={{
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: pageNum <= 1 ? "not-allowed" : "pointer",
                  opacity: pageNum <= 1 ? 0.45 : 1,
                  borderRadius: "8px",
                  border: "1px solid #D1D5DB",
                  backgroundColor: "white",
                  color: "#374151"
                }}
              >
                <NavigateBeforeIcon style={{ fontSize: 18 }} /> Anterior
              </button>

              <span
                style={{
                  fontSize: "12.5px",
                  fontWeight: 700,
                  padding: "5px 12px",
                  background: "#F1F5F9",
                  borderRadius: "8px",
                  color: "#1E293B",
                  border: "1px solid #E2E8F0"
                }}
              >
                {pageNum} / {totalPages || 1}
              </span>

              <button
                type="button"
                disabled={pageNum >= totalPages}
                onClick={() => onPageChange ? onPageChange(pageNum + 1) : (setCurrentPage && setCurrentPage(prev => (pageNum < totalPages ? prev + 1 : prev)))}
                className="btn-secondary-custom"
                style={{
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: pageNum >= totalPages ? "not-allowed" : "pointer",
                  opacity: pageNum >= totalPages ? 0.45 : 1,
                  borderRadius: "8px",
                  border: "1px solid #D1D5DB",
                  backgroundColor: "white",
                  color: "#374151"
                }}
              >
                Siguiente <NavigateNextIcon style={{ fontSize: 18 }} />
              </button>
            </div>
          </div>
        );
      })()}

      {/* =========================================================================
          3. MODAL DE REGISTRO / EDICIÓN (IMAGEN 1: IDENTIFICACIÓN DEL MEZCAL Y CONTENEDOR)
      ========================================================================= */}

      {/* =========================================================================
          3. MODAL DE REGISTRO / EDICIÓN (IDENTIFICACIÓN DEL MEZCAL Y CONTENEDOR)
      ========================================================================= */}
      <ModalFormGranel
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        formData={formData}
        setFormData={setFormData}
        handleSaveGranel={handleSaveGranel}
        envasadoInstalaciones={envasadoInstalaciones}
        activeCatalog={activeCatalog}
      />

      {/* =========================================================================
          4. MODAL DETALLE COMPLETO (INVENTARIOS, ENTRADAS Y SALIDAS)
      ========================================================================= */}
      <ModalDetalleGranel
        isOpen={!!selectedRecord}
        record={selectedRecord}
        onClose={() => setSelectedRecord(null)}
        handleEditRecord={handleEditRecord}
        handleUndoGranel={handleUndoGranel}
        getInstalacionAlias={getInstalacionAlias}
      />

      {/* =========================================================================
          5. MODAL FUSIÓN / MEZCLA / EXTRACCIÓN PARCIAL DE GRANELES
      ========================================================================= */}
      <ModalFusionGranel
        isOpen={isFusionModalOpen}
        onClose={() => setIsFusionModalOpen(false)}
        allAvailableGraneles={allAvailableGraneles}
        activeCatalog={activeCatalog}
        handleSaveFusion={handleSaveFusion}
        handleSaveGranel={handleSaveGranel}
      />

      {/* =========================================================================
          6. MODAL DE TRASLADO ENTRE INSTALACIONES
      ========================================================================= */}
      <ModalTrasladoGranel
        isOpen={isTrasladoModalOpen}
        onClose={() => setIsTrasladoModalOpen(false)}
        trasladoForm={trasladoForm}
        setTrasladoForm={setTrasladoForm}
        allAvailableGraneles={allAvailableGraneles}
        availableInstalaciones={availableInstalaciones}
        handleSaveTraslado={handleSaveTraslado}
      />

      {/* =========================================================================
          7. MODAL DE DILUCIÓN / AJUSTE CON AGUA DESMINERALIZADA
      ========================================================================= */}
      <ModalDilucionGranel
        isOpen={isDilucionModalOpen}
        onClose={() => setIsDilucionModalOpen(false)}
        dilucionForm={dilucionForm}
        setDilucionForm={setDilucionForm}
        allAvailableGraneles={allAvailableGraneles}
        handleSaveDilucion={handleSaveDilucion}
      />

      {/* =========================================================================
          8. MODAL DE SALIDAS O BAJAS DE PRODUCTO (MERMAS / VENTAS)
      ========================================================================= */}
      <ModalBajaGranel
        isOpen={isBajaModalOpen}
        onClose={() => setIsBajaModalOpen(false)}
        bajaForm={bajaForm}
        setBajaForm={setBajaForm}
        allAvailableGraneles={allAvailableGraneles}
        handleSaveBaja={handleSaveBaja}
      />

      {/* =========================================================================
          9. MODAL DE SALIDAS A MUESTREO DE PRODUCTO (NOM-070 / UI)
      ========================================================================= */}
      <ModalMuestreoGranel
        isOpen={isMuestreoModalOpen}
        onClose={() => setIsMuestreoModalOpen(false)}
        muestreoForm={muestreoForm}
        setMuestreoForm={setMuestreoForm}
        allAvailableGraneles={allAvailableGraneles}
        handleSaveMuestreo={handleSaveMuestreo}
      />

      {/* =========================================================================
          10. MODAL DE HISTORIAL DE MOVIMIENTOS Y AUDITORÍA DE TRAZABILIDAD
      ========================================================================= */}
      <ModalMovimientosGranel
        isOpen={isMovimientosModalOpen}
        onClose={() => setIsMovimientosModalOpen(false)}
        granelRecords={granelRecords}
        allGranelRecords={allGranelRecords}
        selectedLote={selectedLoteForMovimientos}
        getInstalacionAlias={getInstalacionAlias}
      />

      {/* =========================================================================
          11. MODAL DE EXPEDIENTE DE DOCUMENTOS DE GRANEL DE ALMACÉN
      ========================================================================= */}
      <ModalDocumentosGranelAlmacen
        isOpen={isDocumentosModalOpen}
        onClose={() => {
          setIsDocumentosModalOpen(false);
          setDocumentosModalRecord(null);
        }}
        granel={documentosModalRecord}
        onDocumentChange={handleRefresh}
      />
    </div>
  );
};

export default InventarioGranelSection;
